import {
  Box,
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  useColorModeValue,
} from "@chakra-ui/react";
import { ErrorMessage } from "@hookform/error-message";
import { RiCloseLine } from "@remixicon/react";
import { useCallback } from "react";
import { useFormContext } from "react-hook-form";

import { SimpleIconButton } from "@/common/components/CommonIconButtons";
import OrgLogo from "@/common/components/OrgLogo";
import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import { UploadLogoButton } from "@/global-settings/components/UploadLogoButton";

export default function OrganizationLogoPicker() {
  const form = useFormContext();
  const { org } = useEnvironment();

  const removeButtonBg = useColorModeValue("white", "gray.800");

  const orgId = org.id;
  const logoUrl = form.watch("logoUrl");

  const setLogoUrl = useCallback(
    (url: string | null) => {
      form.setValue("logoUrl", url, {
        shouldDirty: true,
        shouldTouch: true,
        shouldValidate: true,
      });
    },
    [form],
  );

  return (
    <FormControl>
      <FormLabel>Logo</FormLabel>
      <Flex direction="column" gap={3} placeItems="flex-start">
        <Box pos="relative">
          <OrgLogo name={org.name} size="xl" url={logoUrl} />
          <Box pos="absolute" right={-2} top={-2}>
            {logoUrl && (
              <SimpleIconButton
                bg={removeButtonBg}
                icon={<RiCloseLine size={16} />}
                label="Remove"
                size="2xs"
                variant="outline"
                onClick={() => setLogoUrl(null)}
              />
            )}
          </Box>
        </Box>
        <UploadLogoButton orgId={orgId} onChange={setLogoUrl}>
          {({ onClick }) => (
            <Button variant="outline" onClick={onClick}>
              Upload an image
            </Button>
          )}
        </UploadLogoButton>
      </Flex>
      <FormErrorMessage>
        <ErrorMessage name="logo" />
      </FormErrorMessage>
    </FormControl>
  );
}
